import { useState } from 'react';

import { Button } from '#/components/Button/Button';
import { useLoggedIn } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useRsvpAnswer } from '#/modules/listing/events/hooks/useRsvpAnswer';
import { RsvpRegistrationModal } from '#/modules/listing/events/modals/RsvpRegistrationModal';

type Props = {
  listingId: string;
};

export function RsvpButton({ listingId }: Props) {
  const { i18n } = useI18n();
  const { loggedIn } = useLoggedIn();
  const { ownRsvp, setOwnRsvp } = useRsvpAnswer(listingId, false);
  const [showModal, setShowModal] = useState(false);

  if (ownRsvp?.answer === 'GOING') {
    return (
      <Button
        type="button"
        qaId="rsvp-button"
        disabled
        variant="primary"
        icon={{ name: 'simple-check', color: 'brandGreen' }}
      >
        {
          /* TRANSLATORS: event CTA once registered */
          i18n("You're Going")
        }
      </Button>
    );
  }

  return (
    <>
      <Button
        type="button"
        qaId="rsvp-button"
        variant="primary"
        onClick={() => setShowModal(true)}
      >
        {loggedIn ? i18n('RSVP') : i18n('Register')}
      </Button>

      {showModal && (
        <RsvpRegistrationModal
          eventId={listingId}
          onRegistered={setOwnRsvp}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
}
